import withSearchbarOnScroll from '../../lib/withSearchbarOnScroll';
import BusinessProVisitorLoggedOut from '../BusinessProVisitorLoggedOut';

/**
 * @param {HeaderProps} props
 * @returns {React.ReactElement} Header
 */
export default withSearchbarOnScroll(BusinessProVisitorLoggedOut);
